module.exports = __webpack_public_path__ + "static/media/wrinkles_marionette.c8f1eeab.svg";